import {useRootStore} from '@/store'
import {selectChatFavTopicsSetLanguagesMethod} from '@/store/selectors'
import {useEffect} from 'react'
import {useGetAllLanguages} from './useGetAllLanguages'

export const useChatFavTopics = () => {
    const setLanguages = useRootStore(selectChatFavTopicsSetLanguagesMethod)

    const {languages} = useGetAllLanguages()

    useEffect(() => {
        if (languages) setLanguages(languages)
    }, [languages])

    return {}
}
